var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "reseller-login" }, [
    _c("div", { staticClass: "container" }, [
      _c("div", { staticClass: "row justify-center" }, [
        _c("div", { staticClass: "md:w-1/2 lg:w-5/12 w-full" }, [
          _c(
            "div",
            { staticClass: "lg:px-20" },
            [
              _c("div", { staticClass: "mb-20 text-center" }, [
                _c("h1", { staticClass: "h4 mb-8" }, [
                  _vm._v(_vm._s(_vm.translations.login_title))
                ]),
                _vm._v(" "),
                _c("p", { staticClass: "mb-0" }, [
                  _vm._v(_vm._s(_vm.translations.login_description))
                ])
              ]),
              _vm._v(" "),
              _vm.message != ""
                ? _c(
                    "div",
                    {
                      staticClass:
                        "bg-blue rounded-xs text-14 flex items-center w-full px-16 py-16 font-medium leading-snug text-white"
                    },
                    [_vm._v(_vm._s(_vm.message))]
                  )
                : _vm._e(),
              _vm._v(" "),
              _c(
                "el-form",
                {
                  staticClass: "mt-20 mb-24",
                  attrs: {
                    loading: _vm.loading,
                    success: _vm.success,
                    error: _vm.server_error,
                    "button-class":
                      "btn btn-green btn-lg btn-rounded w-full mt-8 font-bold",
                    "submit-text": _vm.translations.login_button
                  },
                  on: { submit: _vm.submit }
                },
                [
                  _c("el-input", {
                    staticClass: "mb-16",
                    attrs: {
                      rules: "required",
                      label: _vm.translations.login_field
                    },
                    model: {
                      value: _vm.formData.email,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "email", $$v)
                      },
                      expression: "formData.email"
                    }
                  }),
                  _vm._v(" "),
                  _c("el-input", {
                    staticClass: "mb-16",
                    attrs: {
                      type: "password",
                      rules: "required",
                      label: _vm.translations.password_field
                    },
                    model: {
                      value: _vm.formData.password,
                      callback: function($$v) {
                        _vm.$set(_vm.formData, "password", $$v)
                      },
                      expression: "formData.password"
                    }
                  })
                ],
                1
              ),
              _vm._v(" "),
              _c("div", { staticClass: "text-center" }, [
                _c(
                  "a",
                  {
                    staticClass:
                      "hover:border-transparent text-black transition-colors border-b border-black",
                    attrs: { href: "/wachtwoord-vergeten" }
                  },
                  [_vm._v(_vm._s(_vm.translations.password_reset))]
                )
              ])
            ],
            1
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }